exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.padding5_6[data-v-c4d6b156] {\n  padding: 0.5rem 0.6rem 0rem;\n}\n.imgbox[data-v-c4d6b156] {\n  width: 100%;\n  height: auto;\n}\n.imgbox img[data-v-c4d6b156] {\n  width: 100%;\n}", ""]);

// exports
